import React from 'react'
import PropTypes from 'prop-types'
import { t } from '@sportninja/common/i18n'

import MapCard from '../../components/MapCard'
import { Container, Column } from '../../components/Layout'
import Card from '../../components/Card'
import GameDetailsScoreBox from './GameScoreBox'
import GameDetailsStats from './GameDetailsStats'
import { Mobile } from '../../components/Responsive'
import GameShootout from './GameShootout'

const Details = ({ game, isSoccer = false }) => {
  if (!game) return false
  const { homeTeam, visitingTeam, referees, scorekeepers, location, facility } =
    game
  const teams = [homeTeam, visitingTeam]
  const officials = [...referees, ...scorekeepers]

  return (
    <>
      <Mobile>
        {(isMobile) => {
          return isMobile ? (
            <>
              <GameDetailsScoreBox game={game} isMobile isSoccer={isSoccer} />
              <GameShootout game={game} isMobile />
              <GameDetailsStats game={game} isMobile isSoccer={isSoccer} />
            </>
          ) : (
            <Container>
              <Column fullWidth>
                <GameDetailsScoreBox game={game} isSoccer={isSoccer} />
                <GameShootout game={game} />
                <GameDetailsStats game={game} isSoccer={isSoccer} />
              </Column>
            </Container>
          )
        }}
      </Mobile>
      <Container as='main'>
        <MapCard
          venue={location}
          title={t('common:location')}
          facility={facility}
        />

        {teams.map((team, idx) => {
          const sectionTitle = idx === 0 && t('common:team', { count: 2 })
          return (
            <Card
              key={team.fullName}
              iconName='user-friends'
              imageId={team.imageId}
              isEntity
              sectionTitle={sectionTitle}
              subTitle={team.parentName}
              title={team.fullName}
              to={
                team.isPlaceholder
                  ? undefined
                  : `${team.to}?${game.parentScheduleType}=${game.parentId}`
              }
            />
          )
        })}

        {officials.map((user = {}, idx) => {
          const sectionTitle =
            idx === 0 && t('common:gameOfficial', { count: 2 })

          const firstInitial = user?.nameFirst ? user.nameFirst?.charAt(0) : ''
          const lastInitial = user?.nameLast ? user.nameLast?.charAt(0) : ''

          return (
            <Card
              key={`${user.fullName}-${user.description}-${idx}`}
              imageId={user.imageId}
              sectionTitle={sectionTitle}
              subTitle={user.description}
              initials={`${firstInitial}${lastInitial}`}
              // TODO: Add back when we will allow users to navigate to user profiles
              // to={user.to}
              title={user.fullName ? user.fullName : 'No Name'}
            />
          )
        })}
      </Container>
    </>
  )
}

Details.propTypes = {
  game: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
}

export default Details
